<template>
  <div>
    <pdf-view :pdfUrl="pdfUrl"></pdf-view>
    <myAudio :goods_course_id="goods_course_id" ref="audio"></myAudio>

    <!-- 未学习 -1  学习中 0 已学完 1 ？？这样 -->
    <div class="title" style="padding-top: 20px;">
      <template v-if="baseInfo.category_id != '226' && baseInfo.id != 774">
        <span></span>
        <p>理论课程</p><span></span>
      </template>
    </div>
    <div class="lesson-item" v-for="(item, index) of list1" :key="item.id">
      <div class="title1" v-if="item.lesson && item.lesson.length" @click="changeShow(index, 1)">
        <div class="ellipsis2">{{ item.name }}</div>
        <button @click.stop="toViewImg(item)" v-if="item.map.length">
          思维导图
        </button>
        <i :class="{
          'el-icon-arrow-down': !item.show,
          'el-icon-arrow-up': item.show,
        }"></i>
      </div>
      <div class="title1" v-else @click="toPlay(1, item)">
        <div :class="{ yellow: item.study_status == 0 }">
          <p>
            <span class="ellipsis2">{{ item.name }}</span>
            <span class="green" v-if="item.test_status == 1">随堂练习已通过</span>
            <span class="red" v-if="item.test_status == 2">随堂练习未通过</span>
          </p>

          <span v-if="item.study_status == 0">学习中</span>
          <!-- <span  v-if="item.study_status == -1">未学习</span> -->
          <span v-if="item.study_status == 1">已学完</span>

        </div>
        <button @click.stop="toViewImg(item)" v-if="item.map.length">
          思维导图
        </button>
        <van-icon name="play" color="#F08E00" v-if="item.study_status == -1" />
      </div>
      <div class="lesson-detail" v-if="item.show && item.lesson && item.lesson.length">
        <div v-for="(v, i) in item.lesson" :key="i">
          <div class="title2" v-if="v.speak && v.speak.length">
            <div class="ellipsis2">{{ v.name }}</div>
            <button @click.stop="toViewImg(v)" v-if="v.map.length">
              思维导图
            </button>
          </div>
          <div class="title2" v-else @click="toPlay(2, item, v)">
            <div :class="{ yellow: v.study_status == 0 }">
              <p>
                <span class="ellipsis2">{{ v.name }}</span>
                <span class="green" v-if="v.test_status == 1">随堂练习已通过</span>
                <span class="red" v-if="v.test_status == 2">随堂练习未通过</span>
              </p>
              <span v-if="v.study_status == 0">学习中</span>
              <!-- 未学习 -->
              <!-- <span v-if="v.study_status == -1"><van-icon name="play" /></span>  -->
              <span v-if="v.study_status == 1">已学完</span>

            </div>
            <van-icon name="play" color="#F08E00" v-if="v.study_status == -1" />
          </div>
          <div class="list3" v-if="v.speak && v.speak.length">
            <div class="title2" v-for="(vv, ii) in v.speak" :key="ii" @click="toPlay(3, item, v, vv)">
              <div :class="{ yellow: vv.study_status == 0 }">
                <p>
                  <span class="ellipsis2">{{ vv.name }}</span>
                  <span class="green" v-if="vv.test_status == 1">随堂练习已通过</span>
                  <span class="red" v-if="vv.test_status == 2">随堂练习未通过</span>
                </p>
                <span v-if="vv.study_status == 0">学习中</span>
                <!-- <span v-if="vv.study_status == -1">未学习</span> -->
                <span v-if="vv.study_status == 1">已学完</span>

              </div>
              <van-icon name="play" color="#F08E00" v-if="vv.study_status == -1" />
            </div>
          </div>
          <detail-examin :list="v.speak" :testInfo="v.test"
            v-if="v.test.id && baseInfo.category_id != 225"></detail-examin>
        </div>
      </div>
      <detail-examin :list="item.lesson" :testInfo="item.test"
        v-if="item.test.id && (!(item.lesson && item.lesson.length) || item.show) && baseInfo.category_id != 225"
        style="margin-bottom: 10px"></detail-examin>
    </div>
    <div class="title" v-if="list2.length"><span></span>
      <p>实操课程</p><span></span>
    </div>
    <div class="lesson-item" v-for="(item, index) of list2" :key="item.id">
      <div class="title1" v-if="item.lesson && item.lesson.length" @click="changeShow(index, 2)">
        <div class="ellipsis2">{{ item.name }}</div>
        <button @click.stop="toViewImg(item)" v-if="item.map.length">
          思维导图
        </button>
        <i :class="{
          'el-icon-arrow-down': !item.show,
          'el-icon-arrow-up': item.show,
        }"></i>
      </div>
      <div class="title1" v-else @click="toPlay2(1, item)">
        <div :class="{ yellow: item.study_status == 0 }">
          <p>
            <span class="ellipsis2">{{ item.name }}</span>
            <span class="green" v-if="item.test_status == 1">随堂练习已通过</span>
            <span class="red" v-if="item.test_status == 2">随堂练习未通过</span>
          </p>
          <span v-if="item.study_status == 0">学习中</span>
          <!-- <span class="red" v-if="item.study_status == -1">未学习</span> -->
          <span v-if="item.study_status == 1">已学完</span>
        </div>

        <button @click.stop="toViewImg(item)" v-if="item.map.length">
          思维导图
        </button>
        <van-icon name="play" color="#F08E00" v-if="item.study_status == -1" />
      </div>
      <div class="lesson-detail" v-if="item.show && item.lesson && item.lesson.length">
        <div v-for="(v, i) in item.lesson" :key="i">
          <div class="title2" v-if="v.speak && v.speak.length">
            <div class="ellipsis2">{{ v.name }}</div>
            <button @click.stop="toViewImg(v)" v-if="v.map.length">
              思维导图
            </button>
          </div>
          <div class="title2" v-else @click="toPlay2(2, item, v)">
            <div :class="{ yellow: v.study_status == 0 }">
              <p>
                <span class="ellipsis2">{{ v.name }}</span>
                <span class="green" v-if="v.test_status == 1">随堂练习已通过</span>
                <span class="red" v-if="v.test_status == 2">随堂练习未通过</span>
              </p>
              <span class="blue" v-if="v.study_status == 0">学习中</span>
              <!-- <span class="red" v-if="v.study_status == -1">未学习</span> -->
              <span class="green" v-if="v.study_status == 1">已学完</span>
            </div>
            <van-icon name="play" color="#F08E00" v-if="v.study_status == -1" />
          </div>
          <div class="list3" v-if="v.speak && v.speak.length">
            <div class="title2" v-for="(vv, ii) in v.speak" :key="ii" @click="toPlay2(3, item, v, vv)">
              <div :class="{ yellow: vv.study_status == 0 }">
                <p>
                  <span class="ellipsis2">{{ vv.name }}</span>
                  <span class="green" v-if="vv.test_status == 1">随堂练习已通过</span>
                  <span class="red" v-if="vv.test_status == 2">随堂练习未通过</span>
                </p>
                <span class="blue" v-if="vv.study_status == 0">学习中</span>
                <!-- <span class="red" v-if="vv.study_status == -1">未学习</span> -->
                <span class="green" v-if="vv.study_status == 1">已学完</span>
              </div>

              <van-icon name="play" color="#F08E00" v-if="vv.study_status == -1" />
            </div>
          </div>
        </div>
      </div>

      <detail-video :list="item.lesson" @updata="upVideo" :testInfo="{
        time: item.video_time,
        name: item.name,
        status_name: item.video_status,
        video_url: item.video_url,
        id: item.id,
        discipline_id: item.discipline_id,
        study_status: item.study_status,
      }" v-if="!(item.lesson && item.lesson.length) || item.show" style="margin-bottom: 10px">
      </detail-video>
    </div>
    <el-dialog title="思维导图" :visible.sync="dialogTableVisible">
      <div style="height: 480px; overflow: auto">
        <img :src="item.cover" v-for="(item, index) of imgList" :key="index" alt="" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import detailExamin from './detailExamin.vue'
import detailVideo from './detailVideo.vue'
import myAudio from "@/components/audioPlay.vue"
import { ImagePreview } from 'vant';
import pdfView from '@/components/pdfView.vue'
export default {
  components: { detailExamin, detailVideo, myAudio, pdfView },

  props: ["list", 'down_list', "name", "isBuy", "goods_course_id", "baseInfo", 'price'],
  data() {
    return {
      pdfUrl: '',
      list1: [],
      list2: [],
      audioList1: [],
      audioList2: [],
      dialogTableVisible: false,
      imgList: [],
      height: 0,
      top: 0,
      playImg:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/play.jpg",
    };
  },
  watch: {
    list: {
      handler() {
        let list = this.list.map((item) => {
          item.show = false;
          return item;
        });
        this.list1 = list
        this.audioList1 = this.flatArr(this.list, []).filter(item => item.video_ids && item.video_ids[0].type == 3)
      },
      immediate: true
    },
    down_list: {
      handler() {
        let list = this.down_list.map((item) => {
          item.show = false;
          return item;
        });
        this.list2 = list
        this.audioList2 = this.flatArr(this.list2, []).filter(item => item.video_ids && item.video_ids[0].type == 3)
      },
      immediate: true
    }
  },
  computed: {
    plat() {
      return this.$store.state.plat_id;
    },
    myUser() {
      return this.$store.state.user;
    },
    vipInfo() {
      return this.$store.state.vipInfo;
    },
    platName() {
      return this.$store.state.plat.name;
    },
  },
  mounted() { },
  methods: {
    upVideo(type) {
      this.$emit('updata', type)
    },
    changeShow(index, type) {
      this["list" + type][index].show = !this["list" + type][index].show;
      this.$set(this["list" + type], index, this["list" + type][index]);
      console.log(this["list" + type][index].show)
    },
    toPlay(type, item, v, vv) {
      if (this.plat == '121') {
        this.$emit('playVideo', item)
        return
      }
      window.sessionStorage.setItem(this.$route.query.id, true)
      if (this.isBuy == 0 && this.price && this.myUser.mobile != '18666666666') {
        this.$toast("请购买后开始学习");
        return;
      }
      // if(this.baseInfo && this.baseInfo.playmode_id == 17){//pdf资源  
      //   if(type == 1){
      //     this.pdfUrl =  item.pdf_an || item.pdf_ppt || item.pdf_examine
      //   }
      //   if(type == 2){
      //     this.pdfUrl = v.pdf_an || v.pdf_ppt || v.pdf_examine
      //   }
      //   if(type == 3){
      //     this.pdfUrl = vv.pdf_an || vv.pdf_ppt || vv.pdf_examine
      //   }
      //   if(!this.pdfUrl){
      //     this.$toast("当前章节没有资料");
      //    return
      //   }
      // }
      if (type == 1 && !item.video_ids && !item.pdf_an && !item.pdf_ppt && !item.pdf_examine
        || type == 2 && !v.video_ids && !v.pdf_an && !v.pdf_ppt && !v.pdf_examine
        || type == 3 && !vv.video_ids && !vv.pdf_an && !vv.pdf_ppt && !vv.pdf_examine
      ) {
        this.$toast("当前章节没有资料");
        return;
      }
      let isAudio = 0
      let url = "./playerYingyou";
      if (type == 1) {
        if (item.video_ids && item.video_ids[0].type == 3) {//音频
          isAudio = item.id
        }
        url = url + "?chapter_id=" + item.id;
      } else if (type == 2) {
        if (v.video_ids && v.video_ids[0].type == 3) {//音频
          isAudio = v.id
        }
        url = url + "?chapter_id=" + item.id + "&lesson_id=" + v.id;
      } else if (type == 3) {
        if (vv.video_ids && vv.video_ids[0].type == 3) {//音频
          isAudio = vv.id
        }
        url =
          url +
          "?chapter_id=" +
          item.id +
          "&lesson_id=" +
          v.id +
          "&speak_id=" +
          vv.id;
      }
      url = url + "&id=" + this.$route.query.id;
      if (isAudio) {
        let audioIndex = this.audioList1.findIndex(audioItem => audioItem.id == isAudio)
        this.audioList = this.audioList1
        console.log(this.audioList)
        this.$refs.audio.getData(this.audioList1, audioIndex)
      } else {
        this.$router.push(url);
      }
    },
    toPlay2(type, item, v, vv) {

      window.sessionStorage.setItem(this.$route.query.id, true)
      if (this.isBuy == 0 && this.price) {
        this.$toast("请购买后开始学习");
        return;
      }
      // if(this.baseInfo && this.baseInfo.playmode_id == 17){//pdf资源
      //   if(type == 1){
      //     this.pdfUrl = item.pdf_url
      //   }
      //   if(type == 2){
      //     this.pdfUrl = v.pdf_url
      //   }
      //   if(type == 3){
      //     this.pdfUrl = vv.pdf_url
      //   }
      //   if(!this.pdfUrl){
      //     this.$toast("当前章节没有资料");
      //   }
      //   return
      // }
      if (type == 1 && !item.video_ids && !item.pdf_an && !item.pdf_ppt && !item.pdf_examine
        || type == 2 && !v.video_ids && !v.pdf_an && !v.pdf_ppt && !v.pdf_examine
        || type == 3 && !vv.video_ids && !vv.pdf_an && !vv.pdf_ppt && !vv.pdf_examine
      ) {
        this.$toast("当前章节没有资料");
        return;
      }
      let isAudio = 0
      let url = "./playerYingyou?lessonType=down";
      if (type == 1) {
        if (item.video_ids[0].type == 3) {//音频
          isAudio = item.id
        }
        url = url + "&chapter_id=" + item.id;
      } else if (type == 2) {
        if (v.video_ids[0].type == 3) {//音频
          isAudio = v.id
        }
        url = url + "&chapter_id=" + item.id + "&lesson_id=" + v.id;
      } else if (type == 3) {
        if (vv.video_ids[0].type == 3) {//音频
          isAudio = vv.id
        }
        url =
          url +
          "&chapter_id=" +
          item.id +
          "&lesson_id=" +
          v.id +
          "&speak_id=" +
          vv.id;
      }
      url = url + "&id=" + this.$route.query.id;
      if (isAudio) {
        let audioIndex = this.audioList2.findIndex(audioItem => audioItem.id == isAudio)
        this.$refs.audio.getData(this.audioList2, audioIndex)
      } else {
        this.$router.push(url);
      }
    },
    toViewImg(v) {
      if (v.map.length) {
        ImagePreview(v.map.map(item => item.cover));
      }
    },
    flatArr(arr, idArr) {
      let myArr = [];

      arr.forEach((item) => {
        if (item.lesson && item.lesson.length) {
          // console.log("lesson");
          let arr = [
            { label: "lessonId", value: item.id },
            { label: "myType", value: "chapter" },
          ];
          // console.log(idArr);
          myArr.push(...this.flatArr(item.lesson, [...idArr, ...arr]));
        } else if (item.speak && item.speak.length) {
          // console.log("speak");
          let arr = [
            { label: "chapterId", value: item.id },
            { label: "myType", value: "speak" },
          ];
          myArr.push(...this.flatArr(item.speak, [...idArr, ...arr]));
        } else {
          // console.log("none");
          idArr.forEach((v) => {
            item[v.label] = v.value;
          });
          myArr.push(item);
        }
      });
      return myArr;
    },
  },
};
</script>

<style scoped lang="scss">
.pdfView {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  background-color: #fff;

  .pdfUrl {
    max-width: 90%;
    max-height: 90%;
    position: absolute;
    left: 5%;
    top: 5%;
    overflow-y: auto;
  }

  .closeicon {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    color: #000;
    font-size: 40px;
  }
}

.title {
  font-size: 16px;
  padding: 6px 32px 30px;
  padding-bottom: 30px;
  display: flex;
  align-items: center;

  span {
    flex: 1;
    height: 2px;
    display: block;
    background: rgba(0, 0, 0, 0.1);
  }

  p {
    padding: 0 22px;
    font-size: 20px;
    font-weight: 400;
    color: #999999;
  }
}

.blue {
  background: #cee7f8;
  color: #0080d6;
}

.red {
  color: #F33B2E;
  font-size: 20px;
  font-weight: 400;
  display: block;
}

.green {
  color: #999999;
  font-size: 20px;
  font-weight: 400;
  display: block;
}

.lesson-item {
  background: #F7F7F7;
  cursor: pointer;
  overflow: hidden;
  border-radius: 12px;
  margin: 0 32px 20px;
  font-size: 28px;
  padding: 10px 0;

  .title1 {
    display: flex;
    align-items: center;
    height: 80px;
    padding-left: 24px;
    padding-right: 20px;

    >div {
      flex: 1;
      font-weight: 500;
      color: #000000;
      display: flex;
      align-items: center;

      p {
        flex: 1;

      }
    }

    >button {
      font-size: 24px;
      font-weight: 400;
      color: #F08E00;
      line-height: 48px;
      width: 128px;
      height: 48px;
      background: #FFFFFF;
      border-radius: 32px;
      border: 1px solid #F08E00;
      margin-left: 26px;
    }

    i {
      color: #666666;
    }
  }

  .lesson-detail {
    padding-bottom: 10px;

    .title2 {
      display: flex;
      align-items: center;
      height: 80px;
      padding-left: 44px;
      padding-right: 24px;
      font-weight: 400;
      color: #000;

      >div {
        flex: 1;
        display: flex;
        align-items: center;

        p {
          flex: 1;
          width: calc(100% - 100px - 38px);

          span.ellipsis2 {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            height: 80px;
            line-height: 80px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        >span {
          flex-shrink: 0;
          width: 100px;
        }
      }

      >button {
        font-size: 24px;
        font-weight: 400;
        color: #F08E00;
        line-height: 48px;
        width: 128px;
        height: 48px;
        background: #FFFFFF;
        border-radius: 32px;
        border: 1px solid #F08E00;
        margin-left: 26px;
      }

      >span {
        color: #999;
      }
    }

    .list3 {
      padding-bottom: 10px;

      .title2 {
        color: #666666;
        font-weight: 400;
        padding-left: 84px;
      }
    }
  }

  .yellow {
    color: #F08E00;
  }

  .play-btn {
    width: 27px;
    height: 27px;
    background: url("https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BC%96%E7%BB%84%202%E5%A4%87%E4%BB%BD%202%402x.png") no-repeat center / contain;
  }

  .lesson-audio {
    flex: 1;
    margin: auto 0;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    height: 60px;
  }

  .lesson-audio .lesson-title {
    line-height: 22px;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    position: relative;
    font-size: 16px;
    display: -webkit-box;
    overflow: hidden;
    margin-bottom: 5px;
  }

  .lesson-msg {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 26px;
    color: #666;
    width: 100%;
  }

  .lesson-msg .lesson-time,
  .lesson-msg .lesson-count,
  .lesson-msg .lesson-status {
    display: flex;
    align-items: center;
    color: #666;
    margin-right: 20px;
    white-space: nowrap;
  }

  .lesson-msg img {
    height: 14px;
    margin-right: 5px;
  }

  .lesson-video {
    position: relative;
    float: left;
    margin-right: 10px;
  }

  .lesson-video img {
    display: block;
    width: 108px;
    height: 60px;
    border-radius: 5px;
  }

  .lesson-video .video-duration {
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 10px;
    font-weight: 500;
    color: #fff;
    height: 32px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    padding: 0 3px 3px 0;
  }

  .lesson-video::after {
    display: inline-block;
    position: absolute;
    top: 15px;
    left: 40px;
    content: "";
    width: 30px;
    height: 30px;
    background: url("https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/tuoyu/MTU4NDI2MDIzODA1.png") no-repeat center / contain;
  }
}
</style>